import React from 'react';
import { useGetAllTransactionsQuery, useGetPayoutsQuery } from 'services/payoutsApi';
import { useCurrencyFormat } from 'hooks/useCurrencyFormat';
import { StatusTag } from 'components/core/Chips/StatusTag/StatusTag';
export const BatchInvoicesWidget: React.FC<any> = ({ batchId }) => {
  console.log(batchId);
  const { data, isLoading, isSuccess } = useGetPayoutsQuery({
    filter: {
      payoutBatchTransfer: {
        id: { equalTo: `"${batchId}"` },
      },
    },
    first: 10,
  });

  const { data: transferData, isSuccess: transferSuccess } = useGetAllTransactionsQuery({
    filter: {
      id: { equalTo: `"${batchId}"` },
    },
  });
  let transfer: any;
  if (transferSuccess) {
    transfer = transferData?.payoutBatchTransfers?.nodes[0];
  }

  if (isLoading) {
    return (
      <div className="bg-white rounded-lg p-4 border border-grey-200">
        <div className="animate-pulse">
          <div className="h-4 bg-grey-200 rounded w-20 mb-4"></div>
          <div className="space-y-3">
            <div className="h-3 bg-grey-200 rounded w-full"></div>
            <div className="h-3 bg-grey-200 rounded w-3/4"></div>
          </div>
        </div>
      </div>
    );
  }

  if (!isSuccess || !data?.payouts?.nodes) {
    return null;
  }

  const invoices = data.payouts.nodes;

  const isCheckPayment = () => {
    const payMode = transfer?.pay_mode?.toLowerCase();
    return payMode === 'check' || payMode === 'digital_check';
  };

  return (
    <div className="bg-white rounded-lg p-4 border border-grey-200 shadow-sm">
      <div className="space-y-4 mb-6">
        {invoices.map((invoice: any) => (
          <div key={invoice.id} className="flex justify-between items-start">
            <div className="flex-1">
              <div className="font-medium text-grey-700 text-14s">
                {invoice.coupa_invoice_number || `ID${invoice.number}`}
              </div>
            </div>
            <div className="text-right">
              <div className="font-medium text-grey-700 text-12s">
                {useCurrencyFormat(invoice.amount)}
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="border-t border-grey-200 pt-4">
        <div className="flex justify-between items-center mb-2">
          <div className="font-bold text-grey-900 text-base uppercase">TOTAL</div>
          <div className="font-bold text-grey-900 text-base">
            {useCurrencyFormat(transfer?.amount)}
          </div>
        </div>
        <div className="flex justify-between items-center mb-2">
          <div className="font-medium text-grey-600 text-sm">
            Processing Fee{transfer?.status !== 'paid' ? ' (Estimated)' : ''}
          </div>
          <div className="font-medium text-grey-600 text-sm">
            {useCurrencyFormat(
              transfer?.status !== 'paid'
                ? transfer?.estimated_processing_fee_amount
                : transfer.processing_fee_amount
            )}
          </div>
        </div>
        {transfer.status === 'paid' && (
          <div className="flex justify-between items-center">
            <div className="font-medium text-grey-600 text-sm">Paid Amount </div>
            <div className="font-medium text-grey-600 text-sm">
              {useCurrencyFormat(transfer?.paid_amount)}
            </div>
          </div>
        )}
      </div>
      <div className="text-grey-600 text-xs mt-4 pt-4 border-t border-grey-100">
        Payment Method: {transfer?.pay_mode}
      </div>

      {/* Check Status Section - Only show for check payments */}
      {transfer && isCheckPayment() && (
        <div className="mt-4 pt-4 border-t border-grey-100">
          <div className="space-y-3">
            {transfer.check_number && (
              <div className="flex justify-between items-center">
                <div className="font-medium text-grey-600 text-xs">Check Number</div>
                <div className="font-medium text-grey-900 text-xs">{transfer.check_number}</div>
              </div>
            )}
            {transfer.check_status && (
              <div className="flex justify-between items-center">
                <div className="font-medium text-grey-600 text-xs">Check Status</div>
                <StatusTag status={transfer.check_status} payMode={transfer.pay_mode} />
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
